function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "C885B67F-0D4A-461F-B3AE-6C7A2586692E@3x");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Set",
  transform: "translate(-112.000000, -223.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Phone_1147910",
  transform: "translate(112.000000, 223.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.5,14.234375 C13.203125,14.6875 12.6875,14.953125 12.140625,14.921875 C11.59375,14.890625 10.890625,14.8125 10.40625,14.6875 C8.25,14.125 6.015625,12.78125 4.125,10.890625 C2.234375,9 0.890625,6.765625 0.328125,4.609375 C0.203125,4.125 0.140625,3.4375 0.09375,2.890625 C0.0625,2.359375 0.3125,1.84375 0.765625,1.546875 L2.6875,0.265625 C3.1875,-0.0625 3.859375,0.109375 4.125,0.640625 L5.6875,3.65625 C5.90625,4.078125 5.796875,4.609375 5.421875,4.90625 L4.015625,6 C4.578125,7.046875 5.109375,7.890625 6.140625,8.90625 C7.09375,9.859375 7.921875,10.421875 9,11 L10.109375,9.578125 C10.40625,9.203125 10.9375,9.078125 11.359375,9.3125 L14.390625,10.875 C14.921875,11.140625 15.09375,11.8125 14.765625,12.3125 L13.5,14.234375 Z",
  id: "Path"
}))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.a734b7b3.svg";
export { ForwardRef as ReactComponent };